import ShoeNotFound from "./ShoeNotFound.component";

export default ShoeNotFound;
